import { z } from 'zod';

import { firstLastNameRegEx } from '@libs/common-next';

export const firstNameRequiredMsg = 'First name is required';
export const firstNameInvalidMsg = 'Enter a valid first name';
export const firstNameMaxLengthMsg = 'First name cannot exceed 70 characters';

export const firstNameSchema = z
    .string()
    .trim()
    .min(1, firstNameRequiredMsg)
    .max(70, firstNameMaxLengthMsg)
    .regex(firstLastNameRegEx, firstNameInvalidMsg);

export const lastNameRequiredMsg = 'Last name is required';
export const lastNameInvalidMsg = 'Enter a valid last name';
export const lastNameMaxLengthMsg = 'Last name cannot exceed 70 characters';

export const lastNameSchema = z
    .string()
    .trim()
    .min(1, lastNameRequiredMsg)
    .max(70, lastNameMaxLengthMsg)
    .regex(firstLastNameRegEx, lastNameInvalidMsg);

export const phoneRequiredMsg = 'Phone number is required';
export const phoneInvalidMsg = 'Enter a valid phone number';

const phoneRegEx = /^\(?([2-9][0-8][0-9])\)?([-. ]| - )?([2-9][0-9]{2})([-. ]| - )?([0-9]{4})(\s*x[0-9]+)?$/;

export const phoneSchema = z.string().superRefine((val, ctx) => {
    if (!/\d/.test(val)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: phoneRequiredMsg,
        });
        return;
    }

    if (!phoneRegEx.test(val)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: phoneInvalidMsg,
        });
    }
});
